  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0600/3209/0165/files/20250513-p1.webp",
    // "https://cdn.shopify.com/s/files/1/0600/3209/0165/files/20250513-p2.webp",
    "https://cdn.shopify.com/s/files/1/0600/3209/0165/files/20250513-p3.png?v=1750062302",
    "https://cdn.shopify.com/s/files/1/0600/3209/0165/files/20250513-p4.png?v=1750062313",
    "https://cdn.shopify.com/s/files/1/0600/3209/0165/files/20250513-p5.png",
    "https://cdn.shopify.com/s/files/1/0600/3209/0165/files/20250513-p6.png",
    
  ];


function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 倒计时
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    var swiper = new Swiper('.mySwiper', {
      loop: true,
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
  //   var imgArr = ['https://cdn.shopify.com/s/files/1/0555/2783/3705/files/20250410-pro-1.png', 'https://cdn.shopify.com/s/files/1/0555/2783/3705/files/20250410-pro-2.png']
  //   var imgArr2 = ['https://cdn.shopify.com/s/files/1/0555/2783/3705/files/20250410-pro-3.png', 'https://cdn.shopify.com/s/files/1/0555/2783/3705/files/20250410-pro-4.png']
  //   var imgArr3 = ['https://cdn.shopify.com/s/files/1/0555/2783/3705/files/20250410-pro-5.png', 'https://cdn.shopify.com/s/files/1/0555/2783/3705/files/20250410-pro-6.png']
  //   // style选项
  //   let typeOptions = $('.sp-color li')
  //   // 切换选项
  //   typeOptions.click(function () {
  //     $(this).addClass('active').siblings().removeClass('active')
  //   })
  //   $('#color1 li').click(function () {
  //     var index = $(this).index()
  //     $('.sp-pro-1 img').attr('src', imgArr[index])
  //   })
  //   $('#color2 li').click(function () {
  //     var index2 = $(this).index()
  //     $('.sp-pro-2 img').attr('src', imgArr2[index2])
  //   })
  //   $('#color3 li').click(function () {
  //     var index3 = $(this).index()
  //     $('.sp-pro-3 img').attr('src', imgArr3[index3])
  //   })
  //   $('.link-btn').click(function(){
  //   let id = $(this).siblings().find('.active').attr('data-id')
  //   window.location.href = '/cart/' + id + ':' + 1
  // })
    // style选项
    // $('.cart-btn').click(function () {
    //   $(this).children('img').addClass('on')
    //   setTimeout(function () {
    //     $('.cart-btn').children('img').removeClass('on')
    //   }, 500)
    //   $('.sp-header-top .sp-cart').addClass('on')
    //   setTimeout(function () {
    //     $('.sp-header-top .sp-cart').removeClass('on')
    //   }, 500)
    // })
    // 加入购物车
    // let initNum = 0
    // $('.product-part .cart-btn').click(function () {
    //   var img = $('.top-product>img')
    //   initNum = initNum + 1
    //   if (initNum > 0) {
    //     $('.sp-cart .num').css('background', '#cf0101')
    //   } else {
    //     $('.sp-cart .num').css('background', '#919191')
    //   }
    //   $('#calcNumber').val(1)
    //   $('#cardNum').html(initNum)
    //   var flyer = img[0].cloneNode(true)
    //   flyer.classList.add('sp_clone')
    //   var offset = $('.sp-cart')[0].getBoundingClientRect()
    //   $('.product-part').append(flyer)
    //   $('.sp_clone').css({
    //     width: img.width(),
    //     height: img.height(),
    //     position: 'fixed',
    //     top: img[0].offsetTop,
    //     left: img.offset().left,
    //     'z-index': '9999',
    //   })

    //   let finish = $('.sp-cart')
    //   $('.sp_clone').animate(
    //     {
    //       top: finish[0].offsetTop + 120,
    //       left: finish[0].offsetLeft + finish.width() / 2,
    //       width: 50, // 结束时的大小，根据需要调整
    //       height: 50, // 结束时的大小，根据需要调整
    //       opacity: 0.4,
    //       'z-index': '9999',
    //     },
    //     500,
    //     'linear',
    //     function () {
    //       $(this).animate(
    //         {
    //           width: 0,
    //           height: 0,
    //           opacity: 0,
    //         },
    //         0,
    //         function () {
    //           $('.sp-header-top .sp-cart').addClass('sp-shake')
    //           setTimeout(function () {
    //             $('.sp-header-top .sp-cart').removeClass('sp-shake')
    //           }, 400)
    //           $(this).detach()
    //         }
    //       )
    //     }
    //   )
    // })
  })
   let sp_price1 = 29.99;
  let sp_price2 = 79.99;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }
  let prods = window.product
  function getCur() {
    let color = $('#sp-color div.active').attr('data-val')
    let size = $('#sp-size div.active').attr('data-val')
    return prods.filter(item => item.option1 == color && item.option2 == size)[0]
  }
  function changePrice() {
    let num = $('#calcNumber').val()
    let price = ((getCur().price * num) / 100).toFixed(2)
    let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
    price = (price + '').replace('.', ',')
    compare = (compare + '').replace('.', ',')
    $('.product-part .price-group #sp_price1').html(price)
    $('.product-part .price-group #sp_price2').html(compare)
    let off_font =
      100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
    $('.product-part .sp-brand2 p span').html(off_font)
  }

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice()
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice()
  });
    $(function () {
    $(".sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      // style选项

      let colorOptions = $("#sp-color .sp-option.active").index();
      let sizeOptions = $("#sp-size .sp-option.active").index();
      $(".product-part .sp-img-p")[0].src = spImgList[colorOptions];
      if(sizeOptions == 0){
        $(".product-part .sp-tips").hide()
      }else{
        $(".product-part .sp-tips").show()
      }
      changePrice()
    });
    $('.sp-btn-style').click(function(){
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num;
  })

    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      $(".sp-header-top .sp-cart .num").show();
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
      $(".sp-header-top .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp-header-top .sp-cart").removeClass("on");
      }, 500);
    });
    let initNum = 0;
    $(".product-part .cart-btn").click(function () {
      let spNum = $(".product-part #calcNumber")[0].value;
      var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $("#cardNum").html(result.item_count);
        });
      },
      dataType: "json",
    });
      $("#cardNum").removeClass("sp-gray");
      // handleAddToCart(initNum);

      var img = $(".product-part .sp-img-p");
      // var img = $(".product-part .swiper-slide-active .sp-img");

      var flyer = img[0].cloneNode(true);
      flyer.classList.add("sp_clone");

      $(".product-part").append(flyer);
      $(".sp_clone").css({
        width: img[0].width,
        height: img[0].height,
        position: "fixed",
        top: img[0].offsetTop,
        left: img.offset().left,
        "z-index": "99",
      });

      let finish = $(".sp-cart");
      $(".sp_clone").animate(
        {
          top: finish[0].offsetTop + $('.time-part').height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        "linear",
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach();
            }
          );
        }
      );
    });
  });
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          targetElement.offsetTop -
          $('.sp-header-top').height() -
          $('.time-part').height()
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
